export const FIELD_CONSTANTS = {
  CANCEL: "cancel",
  SAVE: "save",
  TITLE: "Title",
  UPLOAD_MEDIA: "Upload Media",
};
